import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import OctopusAgilePrice from './OctopusAgilePrice';
import WeatherOptimizing from './WeatherOptimizing';
import './AdvancedSetting.css';


function AdvancedSetting(props) {
    const { t } = useTranslation();
    const [activeMenu, setActiveMenu] = useState(0) 

    return (
        <div className="advanced-setting">
            <div className="left-nav"> 
                <ul>
                    <li className={activeMenu==0 ? 'active' : null} onClick={() => setActiveMenu(0)} style={{textAlign: 'center'}}>{t('Octopus Agile-Price')}</li>
                    <li className={activeMenu==1 ? 'active' : null} onClick={() => setActiveMenu(1)} style={{textAlign: 'center'}}>{t('Weather Optimizing')}</li>
                </ul>
            </div>
            <div className="right-content"> 
                { 
                    activeMenu == 0 ? <OctopusAgilePrice /> : 
                    activeMenu == 1 ? <WeatherOptimizing /> : 
                    null
                }
            </div>
        </div>
    )
}

export default AdvancedSetting;